<template>
  <div class="check">
    <div v-if="frequency1" class="check_div">
      <div class="genuine">
        <img
          src="../../assets/img/check/setting.png"
          alt=""
          class="genuine_img"
        />
      </div>
      <div class="check_cover">
        <div class="product">
          <img :src="this.str" alt="" class="product_img" />
        </div>
        <div class="GenuinePicture">
          <img
            src="../../assets/img/check/GenuinePicture.png"
            alt=""
            class="GenuinePicture_img"
          />
        </div>
        <div class="introduction">
          <div class="introduction_firstLine">感谢您购买{{this.name}}</div>
          <div class="introduction_SecondRow">
            <div class="introduction_SecondRow_curlycue">{{this.EnglishName}}, </div>
            <!-- <span>，</span> -->
          </div>
          <div class="introduction_ThirdRow">您所扫描的为正品。</div>
        </div>
        <div class="scan">
          <div class="scan_firstLine">首次NFC扫描时间为{{ this.time }},</div>
          <!-- <div class="scan_firstLine">,</div> -->
          <div class="scan_SecondRow">再次扫描将提示为已被扫描或开封。</div>
        </div>
        <div class="procedure">精华使用步骤</div>
        <div class="procedure_box">
          <div
            class="procedure_item"
            v-for="(item, index) in StepIntroduction"
            :key="index"
          >
            <div class="procedure_left">
              <img :src="item.str" alt="" class="procedure_left_img" />
            </div>
            <div class="procedure_right">{{ item.introduce }}</div>
          </div>
          <div class="QRCode2">
        <img src="../../assets/img/check/QRCode2.png" alt="" />
      </div>
        </div>
        
        <div class="product">
          <img :src="this.operationStr" alt="" class="product_img" />
        </div>
      </div>
    </div>
    <div v-if="frequency2" class="pirate">
      <div class="genuine">
        <img
          src="../../assets/img/check/setting2.png"
          alt=""
          class="genuine_img"
        />
      </div>
      <div class="pirate_picture">
        <img :src="this.coverImg" alt="" class="genuine_img" />
      </div>
      <div class="pirate_introduce">
        <div class="pirate_BeScanned">
          <img src="../../assets/img/check/BeScanned.png" alt="" />
        </div>
        <div class="pirate_Used">Used</div>
        <div class="pirate_wordage">
          <div>此NFC码曾于{{ this.time }}被首次扫描过，</div>
          <div>如非您本人扫描，</div>
          <div>您所持有的可能为旧品或赝品，</div>
          <div>请您及时联系商家退货，</div>
          <div>并欢迎拨打400-090-5500向妍诗美社提供举报信息，</div>
          <div>帮助维护您的合法权益。</div>
        </div>
        <div class="pirate_severalTimes">
          <div>
            此次为第{{ this.frequency }}次NFC扫描，时间为{{ this.time2 }},
          </div>
          <div>再次扫描将继续提示为已被扫描。</div>
        </div>
        <div class="pirate_procedure">
          精华使用步骤
          <div class="pirate_procedure_ba"></div>
        </div>
        <div class="pirate_box">
          <div
            class="pirate_item"
            v-for="(item, index) in StepIntroduction2"
            :key="index"
          >
            <div class="pirate_left">
              <img :src="item.str" alt="" class="pirate_left_img" />
            </div>
            <div class="pirate_right">{{ item.introduce }}</div>
          </div>
        </div>
      </div>
      <div class="QRCode">
        <img src="../../assets/img/check/QRCode.png" alt="" />
      </div>
    </div>
    <div v-if="frequency3" class="notHave">
      <img src="../../assets/img/check/wu.jpg" alt="" />
    </div>
  </div>
</template>

<script>
import { verifyData } from "../../api/index";
export default {
  data() {
    return {
      name:'普罗敦焕颜抗皱精华 5ml',
      EnglishName:'Pe beautie Rejuvenate Anti-winkle Renewal Essence',
      frequency: "",
      frequency1: false,
      frequency2: false,
      frequency3: false,
      lookTime: "",
      coverImg: "",
      str: "",
      time: "",
      time2: "",
      operationStr: "",
      StepIntroduction: [
        {
          str: require("../../assets/img/check/use1.png"),
          introduce:
            "将低温运输保持的普罗敦抗皱精华瓶取出，插入配套的小银管底部，听到咔嗒声后卡紧。",
        },
        {
          str: require("../../assets/img/check/use2.png"),
          introduce:
            "将面部用卸妆水、香皂等充分清洗干净， 擦干；或者使用配套（豪华套装中）的洁 面巾（含酒精，敏感肌慎用）擦拭面部， 做深度清理。",
        },
        {
          str: require("../../assets/img/check/use3.png"),
          introduce: "将插有精华瓶的小银管上下颠倒，混匀内 部精华悬液。",
        },
        {
          str: require("../../assets/img/check/use4.png"),
          introduce:
            "将插有精华瓶的小银管轻轻按压底部，直 至小银管头部银球四周溢出液体。",
        },
        {
          str: require("../../assets/img/check/use5.png"),
          introduce:
            "在需要祛皱的面部区域，以来回往复的方 式，用小银管头部银球，反复滚动按压面 部 5 遍，使精华悬液均匀涂布在皮肤表层。",
        },
      ],
      StepIntroduction2: [
        {
          str: require("../../assets/img/check/lose1.png"),
          introduce:
            "将低温运输保持的普罗敦抗皱精华瓶取出，插入配套的小银管底部，听到咔嗒声后卡紧。",
        },
        {
          str: require("../../assets/img/check/lose2.png"),
          introduce:
            "将面部用卸妆水、香皂等充分清洗干净， 擦干；或者使用配套（豪华套装中）的洁 面巾（含酒精，敏感肌慎用）擦拭面部， 做深度清理。",
        },
        {
          str: require("../../assets/img/check/lose3.png"),
          introduce: "将插有精华瓶的小银管上下颠倒，混匀内 部精华悬液。",
        },
        {
          str: require("../../assets/img/check/lose4.png"),
          introduce:
            "将插有精华瓶的小银管轻轻按压底部，直 至小银管头部银球四周溢出液体。",
        },
        {
          str: require("../../assets/img/check/lose5.png"),
          introduce:
            "在需要祛皱的面部区域，以来回往复的方 式，用小银管头部银球，反复滚动按压面 部 5 遍，使精华悬液均匀涂布在皮肤表层。",
        },
      ],
    };
  },
  mounted() {
    let id = this.$route.query.serialNumber;
    console.log(id);
    if (id) {
      verifyData(id).then((res) => {
        if (res.code == 200) {
          this.str = res.result.backgroundImg;
          this.time = res.result.interview_time;
          this.time2 = res.result.currentLookDate;
          this.operationStr = res.result.dynamicImg;
          this.coverImg = res.result.coverImg;
          this.frequency = res.result.lookTime;
          this.name = res.result.productName;
          this.EnglishName = res.result.product_name_en;
          if (this.frequency == 1) {
            this.frequency1 = true;
          } else  {
            this.frequency2 = true;
          } 
        } else {
           this.frequency3 = true;
        }
      });
    } else {
      this.$router.push({ path: "/" });
    }
  },
  methods: {},
};
</script>

<style>
@import "../../assets/css/authentic/index.css";
</style>


// WEBPACK FOOTER //
// src/views/check/index.vue